import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import PageHeader from '../components/common/PageHeader';

const TermsOfServicePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbs = [
    { label: 'Terms of Service' }
  ];

  return (
    <>
      <PageHeader 
        title="Terms of Service" 
        breadcrumbs={breadcrumbs}
      />
      
      <section className="py-16 md:py-24 bg-background">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="prose prose-lg max-w-none"
            >
              <div className="bg-white p-8 rounded-lg shadow-sm mb-8">
                <p className="text-gray-600 mb-8">
                  <strong>Last updated:</strong> {new Date().toLocaleDateString()}
                </p>

                <div className="space-y-8">
                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">1. Acceptance of Terms</h2>
                    <p className="text-gray-700 leading-relaxed">
                      By accessing and using the services provided by Blockfirst Capital ("Company", "we", "us", or "our"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                    </p>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">2. Investment Services</h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      Blockfirst Capital provides investment management and advisory services. Our services include but are not limited to:
                    </p>
                    <ul className="list-disc ml-6 text-gray-700 space-y-2">
                      <li>Portfolio management and investment advisory</li>
                      <li>Financial planning and wealth management</li>
                      <li>Risk assessment and investment strategy development</li>
                      <li>Regulatory compliance and reporting</li>
                    </ul>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">3. Investment Risks</h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      <strong>IMPORTANT:</strong> All investments carry risk and you may lose some or all of your invested capital. Key risks include:
                    </p>
                    <ul className="list-disc ml-6 text-gray-700 space-y-2">
                      <li>Market volatility and potential loss of principal</li>
                      <li>Liquidity risks in certain investment vehicles</li>
                      <li>Currency exchange rate fluctuations</li>
                      <li>Economic and political uncertainties</li>
                      <li>Regulatory changes affecting investments</li>
                    </ul>
                    <p className="text-gray-700 leading-relaxed mt-4">
                      Past performance is not indicative of future results. You should carefully consider your investment objectives and risk tolerance before investing.
                    </p>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">4. Client Responsibilities</h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      As a client, you agree to:
                    </p>
                    <ul className="list-disc ml-6 text-gray-700 space-y-2">
                      <li>Provide accurate and complete information</li>
                      <li>Notify us of any material changes to your financial situation</li>
                      <li>Review all documents and statements carefully</li>
                      <li>Comply with all applicable laws and regulations</li>
                      <li>Pay fees and charges as agreed</li>
                    </ul>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">5. Fees and Charges</h2>
                    <p className="text-gray-700 leading-relaxed">
                      Fee structures will be clearly outlined in your investment agreement. Fees may include management fees, performance fees, and administrative charges. All fees will be disclosed prior to commencement of services.
                    </p>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">6. Confidentiality</h2>
                    <p className="text-gray-700 leading-relaxed">
                      We maintain strict confidentiality regarding your personal and financial information. We will not disclose your information to third parties except as required by law or with your explicit consent.
                    </p>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">7. Limitation of Liability</h2>
                    <p className="text-gray-700 leading-relaxed">
                      Blockfirst Capital's liability shall be limited to the extent permitted by law. We shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services.
                    </p>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">8. Termination</h2>
                    <p className="text-gray-700 leading-relaxed">
                      Either party may terminate the agreement with appropriate notice as specified in your investment agreement. Upon termination, all obligations and liabilities shall be settled in accordance with the terms of your agreement.
                    </p>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">9. Governing Law</h2>
                    <p className="text-gray-700 leading-relaxed">
                      These terms shall be governed by and construed in accordance with the laws of England and Wales.
                    </p>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">10. Contact Information</h2>
                    <p className="text-gray-700 leading-relaxed">
                      For questions regarding these Terms of Service, please contact us:
                    </p>
                    <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                      <p className="text-gray-700">
                        <strong>Blockfirst Capital</strong><br />
                        Email: info@blockfirstcapital.com<br />
                        
                        Address: Colmore Building, 20 Colmore Circus Queensway, Birmingham, England, B4 6AT
                      </p>
                    </div>
                  </section>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfServicePage; 